import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.css';

const Message = ({ icon, type, price, header, text }) => {
  const history = useHistory();

  if (type === 'order')
    return (
      <div className={`${styles.container} drop-shadow`} data-testid="pre-auth-container">
        <img src={icon} alt={icon} data-testid="icon" />
        <div>{text && <p data-testid="text">{text}</p>}</div>
      </div>
    );

  if (type === 'basket-bar') {
    return (
      <>
        <div className={styles.container} data-testid="pre-auth-container">
          <div className={styles.headerContainer}>
            {header && <h1 data-testid="header">{header}</h1>}
            {icon && (
              <div
                data-testid="icon-container"
                onClick={() => history.push('/pharmacy/tooltip/2')}
                style={{ cursor: 'pointer' }}
                >
                <img id="get-more-info" src={icon} alt="get more info" data-testid="icon" />
              </div>
            )}
            <h2 id="basket-medication-price" data-testid="price">
              £{price}
            </h2>
          </div>
          {text && <p data-testid="text">{text}</p>}
        </div>
      </>
    );
  }
};

export default Message;
